module.exports = __webpack_public_path__ + "img/Icon_Report.7da30699.svg";